export default __webpack_public_path__ + "static/catering_2-dc7358ff9158aba133212ef2261d9282.png";